var _g, _g2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvert2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_1_",
    "data-name": "user (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.428,
    height: 55.428,
    viewBox: "0 0 55.428 55.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "translate(33.236 28.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22289",
    "data-name": "Path 22289",
    d: "M328.5,268.7a24.632,24.632,0,0,0-20.777,0,1.191,1.191,0,0,0-.707,1.088v6.77a17.885,17.885,0,0,0,10.612,16.329,1.191,1.191,0,0,0,.967,0A17.885,17.885,0,0,0,329.2,276.559v-6.77A1.191,1.191,0,0,0,328.5,268.7Zm-1.675,7.858a15.5,15.5,0,0,1-8.714,13.928,15.5,15.5,0,0,1-8.714-13.928v-5.984a22.2,22.2,0,0,1,17.428,0Z",
    transform: "translate(-307.013 -266.403)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22290",
    "data-name": "Path 22290",
    d: "M368.191,359.291a1.191,1.191,0,1,0-1.684,1.684l2.335,2.335a1.191,1.191,0,0,0,1.684,0l4.669-4.669a1.191,1.191,0,1,0-1.684-1.684l-3.827,3.827Z",
    transform: "translate(-359.755 -346.843)",
    fill: "#61ce65"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22291",
    "data-name": "Path 22291",
    d: "M119.448,120.459v-1.226a8.779,8.779,0,0,0-5.039-7.934,5.593,5.593,0,1,0-7.711,0,8.779,8.779,0,0,0-5.039,7.934v1.226a1.191,1.191,0,0,0,1.191,1.191h15.408A1.191,1.191,0,0,0,119.448,120.459Zm-8.895-16.418a3.211,3.211,0,1,1-3.211,3.211A3.215,3.215,0,0,1,110.554,104.042Zm6.513,15.227H104.041v-.035a6.394,6.394,0,0,1,6.387-6.387h.252a6.394,6.394,0,0,1,6.387,6.387v.035Z",
    transform: "translate(-90.654 -90.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22292",
    "data-name": "Path 22292",
    d: "M113.017,388.689h13.207a1.191,1.191,0,0,0,0-2.382H113.017a1.191,1.191,0,0,0,0,2.382Z",
    transform: "translate(-99.72 -344.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22293",
    "data-name": "Path 22293",
    d: "M39.8,29.276V12.2a1.2,1.2,0,0,0-.349-.842L28.446.349A1.2,1.2,0,0,0,27.6,0H4.492A4.5,4.5,0,0,0,0,4.492V46.313a4.5,4.5,0,0,0,4.492,4.492H37.7a17.922,17.922,0,0,1-1.767-2.382H4.492a2.113,2.113,0,0,1-2.111-2.111V4.492A2.113,2.113,0,0,1,4.492,2.382H26.413V8.895a4.5,4.5,0,0,0,4.492,4.492h6.513v16.47Q38.608,29.507,39.8,29.276ZM30.905,11.005a2.113,2.113,0,0,1-2.111-2.111V4.066l6.94,6.94Z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2332",
    "data-name": "Ellipse 2332",
    cx: 1.191,
    cy: 1.191,
    r: 1.191,
    transform: "translate(12.106 35.217)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2333",
    "data-name": "Ellipse 2333",
    cx: 1.191,
    cy: 1.191,
    r: 1.191,
    transform: "translate(18.709 35.217)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2334",
    "data-name": "Ellipse 2334",
    cx: 1.191,
    cy: 1.191,
    r: 1.191,
    transform: "translate(25.313 35.217)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert2);
export default __webpack_public_path__ + "static/media/convert2.28460a2f80f1a1652410063960d6c613.svg";
export { ForwardRef as ReactComponent };